import styled from "styled-components";
import { Colors } from "../styled";

export const Container = styled.div`
  margin-bottom: 24px;

  ${({ expanded }) =>
    expanded &&
    `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80vw;
  max-width: 1200px;
  height: 80vh;
  z-index: 9999;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
  `}

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    padding: 0px 24px;
    background: #282828;
    color: #fff;
    font-size: 16px;

    p {
      margin: 0;
      font-size: inherit;
      font-weight: bold;
    }

    .toggle {
      padding: 8px;
      font-size: 1.25em;
      transition: all 0.5s;

      &:hover {
        cursor: pointer;
        transform: rotate(90deg);
      }
    }
  }

  .content {
    display: ${({ expanded, collapsed }) =>
      !expanded && !collapsed ? "none" : "block"};
    flex: 1;
    padding: 32px;
    ${({ expanded }) =>
      !expanded &&
      `
      border: 1px solid ${Colors.Mist};
    `}

    > div {
      min-height: 300px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/core/admin/components/Preview/styled.js